export const GET_ACCOUNT_TYPE = "GET_ACCOUNT_TYPE";
export const GET_CAPTCHA = "GET_CAPTCHA";
export const VERIFY_ACCOUNT = "VERIFY_ACCOUNT";
export const SUBMIT_HKIDR = "SUBMIT_HKIDR";
export const GET_ACCOUNT_INFO = "GET_ACCOUNT_INFO";
export const GET_COUNTRY_LIST = "GET_COUNTRY_LIST";
export const GET_CONSENT_STATUS = "GET_CONSENT_STATUS";